const escolas_que_nao_retornam_vagas = {
  path: "/relatorio-de-apoio-gerencial-escolas-que-nao-retornam-vagas",
  redirect: "/relatorio-de-apoio-gerencial-escolas-que-nao-retornam-vagas",
  meta: {
    breadCrumb:
      "Gerenciamento de Matrícula - Apoio Gerencial de Planejamento da Matrícula",
  },
  children: [
    {
      path: "/relatorio-de-apoio-gerencial-escolas-que-nao-retornam-vagas",
      name: "relatorio_de_apoio_gerencial_escolas_que_nao_retornam_vagas",
      meta: {
        allowedPermissions: ["retorno_vaga_escola_sem_vaga"],
      },
      component: () =>
        import(
          "@/views/RelatorioApoioGerencialEscolasQueNaoRetornamVagas/RelatorioApoioGerencialEscolasQueNaoRetornamVagas.vue"
        ),
    },
  ],
};

export { escolas_que_nao_retornam_vagas };
